import { CallContractResponse, transaction, Call } from 'starknet'
import { Network } from '../services/token.service'
import { getProvider } from '../services/amm'

// eslint-disable-next-line no-unused-vars
export type Callback<P, C> = (value: P) => C

export type BulkCall = {
    call: Call
    responseParser:
        | {
              kind: 'fixed'
              length: number
          }
        | {
              kind: 'dynamic'
          }
        | {
              kind: 'callback'
              callback: Callback<string[], { resp: CallContractResponse; length: number }>
          }
}

export const getBulkCallContractAddress = async (network: Network) => {
    if (network === 'goerli-alpha') return '0x163dd8182a69972b9fc7e95eb0be92b731680212beddfede2eff4ffcfa28bfb'
    if (network === 'sepolia-alpha') return '0x163dd8182a69972b9fc7e95eb0be92b731680212beddfede2eff4ffcfa28bfb'
    if (network === 'mainnet-alpha') return '0x163dd8182a69972b9fc7e95eb0be92b731680212beddfede2eff4ffcfa28bfb'
    return undefined
}

export const bulkCallContract = async (network: Network, calls: BulkCall[], bulkCallContractAddress?: string): Promise<CallContractResponse[]> => {
    const provider = await getProvider(network)
    const contractAddress = bulkCallContractAddress || (await getBulkCallContractAddress(network))!

    const executeCalls = transaction.fromCallsToExecuteCalldata(calls.map((c) => c.call))
    const bulkResponse = await provider.callContract({
        contractAddress: contractAddress,
        entrypoint: 'multi_call_contract',
        calldata: executeCalls
    })

    const parsedResponse: CallContractResponse[] = []
    const bulkResponseLen = parseInt(bulkResponse.result[0], 16)
    if (bulkResponseLen === 0) {
        console.log('[starknet bulk]', 'got 0 length bulk response')
        return []
    }
    let nextRespIdx = 1
    calls.forEach((call, callIdx) => {
        if (call.responseParser.kind === 'fixed') {
            parsedResponse[callIdx] = {
                result: bulkResponse.result.slice(nextRespIdx, nextRespIdx + call.responseParser.length)
            }
            nextRespIdx += call.responseParser.length
        } else if (call.responseParser.kind === 'dynamic') {
            const respLen = parseInt(bulkResponse.result[nextRespIdx], 16)
            if (respLen > 0) {
                parsedResponse[callIdx] = {
                    result: bulkResponse.result.slice(nextRespIdx, nextRespIdx + respLen + 1)
                }
            } else {
                parsedResponse[callIdx] = {
                    result: ['0x0']
                }
            }
            nextRespIdx += respLen + 1
        } else {
            //call.responseParser.kind === "callback"
            const { resp, length } = call.responseParser.callback(bulkResponse.result.slice(nextRespIdx))
            parsedResponse[callIdx] = resp
            nextRespIdx += length
        }
    })

    return parsedResponse
}
